/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useState} from 'react';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import Clipboard from "toolbox/clipboard";

function CopyToClipboardComponent({text, className = ""}) {
    const [wasClicked, setWasClicked] = useState(false);

    const handleCopy = () => {
        Clipboard.set(text);
        setWasClicked(true);
        setTimeout(() => setWasClicked(false), 3000);
    };

    return (
        <div className={`flex h-7 items-center ${className}`}>
            <div className={"grow truncate"}>
                <input
                    type="text"
                    readOnly
                    value={text}
                    onClick={(e) => e.target.select()}
                    className="w-full text-sm text-left truncate bg-transparent outline-none cursor-text focus:ring-0 border-none"
                />
            </div>
            <div className="ml-2 mr-2 shrink-0 text-gray-500 "
                 onClick={handleCopy}>
                <DisplayIcon iconName={wasClicked ? "PiCheck" : "Copy"}
                             className={`size-5! text-gray-700 hover:text-blue-600 cursor-pointer ${wasClicked && "hover:text-green-600 text-green-500"}`}/>
            </div>
        </div>
    );
}

CopyToClipboardComponent.propTypes = {};

export default CopyToClipboardComponent;